import { TextArea, Layer } from '@carbon/react';
import styles from './edit-notes.module.scss';
import commonStyles from './common.module.scss';
import { Checkmark, Close, Edit } from '@carbon/react/icons';
import { useScenarioForm } from './contexts';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import request from 'lib/request';

interface EditNotesProps {
  editingNote: boolean;
  setEditingNote: (editingNote: boolean) => void;
}

export const EditNotes = ({ editingNote, setEditingNote }: EditNotesProps) => {
  const { form, readOnly, baselines, setFieldBaseline } = useScenarioForm();
  const { id: scenarioId } = useParams<{ id: string }>();
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    const notes = form.state.values.globalConfig?.notes ?? '';
    setSaving(true);
    try {
      await request.patch(
        `/type_curve_scenarios/${scenarioId}`,
        { typeCurveScenario: { notes } },
        new AbortController()
      );
      setFieldBaseline?.('globalConfig', {
        ...baselines?.globalConfig,
        notes,
      } as any);
      setEditingNote(false);
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    form.setFieldValue(
      'globalConfig.notes',
      baselines?.globalConfig?.notes ?? ''
    );
    setEditingNote(false);
  };

  return (
    <form.Subscribe selector={(state) => state.values.globalConfig}>
      {(globalConfig) => (
        <div className={commonStyles.configFormContainer}>
          <div className={styles.notesHeader}>
            <h2 className={commonStyles.configFormTitle}>Notes</h2>
            <div className={styles.notesHeaderActions}>
              {!editingNote && !readOnly && (
                <button
                  type="button"
                  className={styles.iconButton}
                  onClick={() => setEditingNote(true)}
                  aria-label="Edit notes"
                >
                  <Edit size={16} />
                </button>
              )}
              {editingNote && (
                <>
                  <button
                    type="button"
                    className={styles.iconButton}
                    onClick={handleSave}
                    disabled={saving}
                    aria-label="Save notes"
                  >
                    <Checkmark size={16} />
                  </button>
                  <button
                    type="button"
                    className={styles.iconButton}
                    onClick={handleCancel}
                    aria-label="Cancel editing"
                  >
                    <Close size={16} />
                  </button>
                </>
              )}
            </div>
          </div>

          {!editingNote && (
            <p
              className={
                globalConfig?.notes ? styles.notesText : styles.notesPlaceholder
              }
            >
              {globalConfig?.notes || 'Add notes...'}
            </p>
          )}

          {editingNote && (
            <form.Field name="globalConfig.notes">
              {(field) => (
                <Layer>
                  <TextArea
                    id="notes-textarea"
                    labelText=""
                    placeholder="Add or edit notes..."
                    rows={4}
                    value={field.state.value || ''}
                    onChange={(e) => field.handleChange(e.target.value)}
                  />
                </Layer>
              )}
            </form.Field>
          )}
        </div>
      )}
    </form.Subscribe>
  );
};
